export const ACTIVATE_SAVE_APPLICATION = 'page/SAVE_APPLICATION [activate]';
export const SAVE_APPLICATION_LOADING = 'page/SAVE_APPLICATION [loading]';
export const SAVE_APPLICATION_COMPLETE = 'page/SAVE_APPLICATION [complete]';
export const SAVE_APPLICATION_FAILED = 'page/SAVE_APPLICATION [failed]';
export const SAVE_APPLICATION_RESET = 'page/SAVE_APPLICATION_RESET';
